import InputToggle from "app/WebController/Component/Form/InputToggle"
import React from "react"
import {Helmet, HelmetProvider} from "react-helmet-async"
import DarkMode from "static/icons/dark_mode_black_24dp.svg"
import LightMode from "static/icons/light_mode_black_24dp.svg"

interface IHeaderModeViewProps {
  themeMode: string,
  toggleThemeMode: () => void
}

function ThemeModeView({themeMode, toggleThemeMode}: IHeaderModeViewProps) {
  return (
    <HelmetProvider>
      <InputToggle
        id={'theme-mode'}
        value={themeMode === 'light'}
        onChange={() => toggleThemeMode()}
        check={<LightMode className={`sun`}/>}
        unchecked={<DarkMode className={`moon`}/>}
      />
      <Helmet>
        <html data-mode={themeMode}/>
      </Helmet>
    </HelmetProvider>
  )
}

export default ThemeModeView
